module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp vux-previewer",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://loading.io/spinners/microsoft/index.svg",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pic-info"
  }, [_c('p', {
    staticClass: "time"
  }, [_vm._v("\n      拍摄时间：" + _vm._s(_vm.pic_time))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_title),
      expression: "pic_title"
    }],
    staticClass: "description"
  }, [_c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.pic_title)
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-info"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "origin"
  }, [_c('span', {
    staticClass: "page"
  }, [_vm._v(_vm._s(_vm.current) + " / " + _vm._s(_vm.total))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOrigin),
      expression: "!isOrigin"
    }],
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showOrigin(_vm.current)
      }
    }
  }, [_vm._v("查看原图(" + _vm._s(_vm.pic_size) + "K)")]), _vm._v(" "), _c('span', {
    staticClass: "download",
    on: {
      "click": function($event) {
        _vm.showPosition('middle')
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-download"
    }
  })])])]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 1500,
      "is-show-mask": "",
      "text": "长按图片保存",
      "position": _vm.position
    },
    model: {
      value: (_vm.showPositionValue),
      callback: function($$v) {
        _vm.showPositionValue = $$v
      },
      expression: "showPositionValue"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('div', {
    staticClass: "pswp__preloader__icn"
  }, [_c('div', {
    staticClass: "pswp__preloader__cut"
  }, [_c('div', {
    staticClass: "pswp__preloader__donut"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })]), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2284d37c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Previewer/Previewer.vue
// module id = 500
// module chunks = 1